import React, { useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import styles from "../Settings.module.scss";
import { toast } from "react-toastify";
import EditClientDocumentType from "./EditClientDocumentType";
import { createLookup } from "api/accountsAPI";
import ClientDocumentTypesList from "./ClientDocumentTypesList";

const ClientDocumentTypes = () => {
  const [addNewForm, setAddNewForm] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      await createLookup("ClientDocumentTypes", {
        key: "ClientDocumentTypes",
        value: data.value,
        active: true,
      });
      toast.success("Document Type Added");
      setAddNewForm(false);
      setRefreshKey((k) => k + 1);
    } catch (_) {
      toast.error("Failed to add Client Document Type");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="d-flex flex-column h-100 w-100 settings-container-sm">
      <div className="d-flex justify-content-end mb-3 flex-shrink-0">
        <Button
          className={`common-btn setting-btn`}
          onClick={() => setAddNewForm(true)}
        >
          Add<br />
          Document Type
        </Button>
      </div>
      <div className="flex-grow-1 mb-2" style={{ minHeight: 0 }}>
        <ClientDocumentTypesList refreshKey={refreshKey} />
      </div>
      {addNewForm && (
        <EditClientDocumentType
          type="addNew"
          isSubmitting={isSubmitting}
          onSubmit={handleSubmit}
          cancelEdit={() => setAddNewForm(false)}
        />
      )}
    </div>
  );
};

export default ClientDocumentTypes;
